import {
  CollapseChevron,
  usePersistentCollapse,
} from "@gearbox-protocol/deploy-tools-ui";
import type { FC, PropsWithChildren, ReactElement } from "react";

import { useUnpausedForkStatus } from "../context";

interface Props {
  id: string;
  title: ReactElement;
  initiallyCollapsed?: boolean;
}

const CollapsiblePanel: FC<PropsWithChildren<Props>> = ({
  id,
  title,
  initiallyCollapsed,
  children,
}) => {
  const { executionId } = useUnpausedForkStatus();
  const { toggleProps, collapseProps, collapsed } = usePersistentCollapse(
    id,
    executionId,
    initiallyCollapsed,
  );
  return (
    <div className="flex flex-col">
      <div {...toggleProps} className="cursor-pointer">
        <div className="flex flex-row items-center justify-between">
          {title}
          <CollapseChevron
            collapsed={collapsed}
            className="fill-slate-50"
            size={24}
          />
        </div>
      </div>

      <div {...collapseProps}>{children}</div>
    </div>
  );
};

export default CollapsiblePanel;
